import {SET_SUBSCRIPTION} from './constant';

export const setSubscription = payload => ({
  type: SET_SUBSCRIPTION,
  payload
});

export const setNewSubscription = organisationId => setSubscription({organisationId, date: new Date()});
